export default __webpack_public_path__ + "static/media/create.520b9578.png";